import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";

//import { getRoutes } from "routes.js";
//import exportDashboardRoutes from 'route.js';

import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";

import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logotipo.png";

import Input from "@material-ui/icons/Input";
import People from "@material-ui/icons/People";
import Store from "@material-ui/icons/Store";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import StreetviewIcon from "@material-ui/icons/Streetview";
import NaturePeopleIcon from "@material-ui/icons/NaturePeople";
import ImageSearchIcon from "@material-ui/icons/ImageSearch";
import BusinessCenter from "@material-ui/icons/BusinessCenter";
import SearchRounded from "@material-ui/icons/SearchRounded";
import BarChartIcon from "@material-ui/icons/BarChart";
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Dashboard from "@material-ui/icons/Dashboard";
import AccountBalanceWallet from "@material-ui/icons/AccountBalanceWallet";
// core components/views for Admin layout

import Usuarios from "views/Catalogos/Catalogos.jsx";
import LogoutPage from "views/LoginPage/LogoutPage.jsx";
import Mapas from "views/Desarrollo/EjemploMapa.jsx";
import Cobranza from "views/Cobranza/Cobranza.jsx";
import CoreBlocks from "views/Manzanas/CoreBlocks.jsx";
import ConsultaDesarrollo from "views/Desarrollo/ConsultaDesarrollo.jsx";
import Desarrollo from "views/Desarrollo/DesarrolloTable.jsx";
import ConsultaCliente from "views/Clientes/ConsultaCliente";
import Contract from "views/Contrato/Contract";
import Estadisticas from "views/Estadisticas/Estadisticas";
import ConfirmacionContrato from "views/Contrato/ConfirmacionContrato";
import SearchFormClients from "components/Clientes/SearchFormClients";
import ControlCaja from "views/ControlCaja/ControlCaja";
import MovimientosCaja from "views/ControlCaja/MovimientosCaja";
import { isSessionValid, getUser, clearSession } from '../utils/sessionUtils';
let ps;

const iconImports = {
  Input: Input,
  People: People,
  Store: Store,
  AttachMoneyIcon: AttachMoneyIcon,
  StreetviewIcon: StreetviewIcon,
  NaturePeopleIcon: NaturePeopleIcon,
  ImageSearchIcon: ImageSearchIcon,
  BusinessCenter,
  SearchRounded,
  BarChartIcon,
  MoneyOffIcon,
  Dashboard,
  AccountBalanceWallet
};
const componentImport = {
  Usuarios,
  LogoutPage,
  Mapas,
  Cobranza,
  CoreBlocks,
  ConsultaDesarrollo,
  Desarrollo,
  ConsultaCliente,
  Contract,
  SearchFormClients,
  Estadisticas,
  ConfirmacionContrato,
  ControlCaja,
  MovimientosCaja
};

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image] = React.useState(bgImage);
  const [color] = React.useState("teal");
  const [routes, setRoutes] = React.useState();

  //const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  const switchRoutes = (
    <Switch>
      {routes &&
        routes.map((prop, key) => {
          if (prop.layout === "/admin") {
            return (
              <Route
                path={prop.layout + prop.path}
                component={prop.component}
                key={key}
              />
            );
          }
          return null;
        })}
      <Redirect from="/admin" to="/admin/estadisticas" />
    </Switch>
  );
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1 && routes) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1 && routes && ps) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  React.useEffect(() => {
    if (!isSessionValid()) {
      clearSession();
      window.location.href = '/login';
      return;
    }

    // Función para cargar las rutas desde el almacenamiento local
    const loadRoutesFromLocalStorage = () => {
      let usuario = localStorage.getItem("user");

      if (usuario) {
        usuario = JSON.parse(usuario);
        if (usuario.menu) {
          const logout = {
            icon: "Input",
            name: "Cerrar Sesión",
            path: "/logout",
            layout: "/admin",
            seccion: "General",
            component: "LogoutPage"
          };
          let data = typeof usuario.menu === 'string' ? JSON.parse(usuario.menu) : usuario.menu;
          data.push(logout);
          const dashboardRoutes = data.map(item => {
            const { icon, component, ...rest } = item;
            const iconComponent = iconImports[icon];
            const componentPath = componentImport[component];

            if (!componentPath) {
              console.warn(`Componente no encontrado: "${component}" para ruta "${rest.name}"`);
            }
            if (!iconComponent) {
              console.warn(`Icono no encontrado: "${icon}" para ruta "${rest.name}"`);
            }

            return {
              ...rest,
              icon: iconComponent || null,
              component: componentPath || null
            };
          }).filter(route => route.component !== null);
          setRoutes(dashboardRoutes);
        } else {
          console.log(
            "La propiedad " +
              usuario.menu +
              " no está definida en el objeto JSON."
          );
        }
      } else {
        console.log(
          "No se ha encontrado ningún valor en el almacenamiento local para la clave. " +
            usuario
        );
      }
    };

    loadRoutesFromLocalStorage();
  }, []);
  return (
    <div className={classes.wrapper}>
      {routes ? (
        <>
          <Sidebar
            routes={routes}
            logo={logo}
            image={image}
            handleDrawerToggle={handleDrawerToggle}
            open={mobileOpen}
            color={color}
            {...rest}
          />
          <div className={classes.mainPanel} ref={mainPanel}>
            <Navbar
              routes={routes}
              handleDrawerToggle={handleDrawerToggle}
              {...rest}
            />
            {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
            {getRoute() ? (
              <div className={classes.content}>
                <div className={classes.container}>{switchRoutes}</div>
              </div>
            ) : (
              <div className={classes.map}>{switchRoutes}</div>
            )}
            {getRoute() ? <Footer /> : null}
          </div>
        </>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
}
